import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import ToolTip from './ToolTip.vue';
import { computed, ref, watch } from 'vue';
import { NUMERIC_REGEX } from '../helpers/regex';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuantityField',
  props: {
	min: { type: Number, default: 1 },
	max: Number,
	interval: { type: Number, default: 1 },
	value: { type: Number, default: 1 },
	disabled: Boolean,
	incrementDisabled: Boolean,
	highlighted: Boolean,
	tooltipError: Boolean,
	tooltipTimeout: { type: Number, default: 3000 },
	hardStopQuantity: Number,
},
  emits: ["max-reached", "input"],
  setup(__props, { emit }: { emit: ({
	(e: 'max-reached'): void;
	(e: 'input', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const disableMinusButton = computed(() => props.disabled || (props.value === props.min));
const disablePlusButton = computed((): boolean =>
	props.disabled
	|| props.incrementDisabled
	|| (props.hardStopQuantity && props.value >= props.hardStopQuantity)
);

const showToolTip = ref<boolean>(false);
const qty = ref<number | null>(null);
const announcedQty = ref<number | null>(null);

function handleMinusClick() {
	let value = props.value;
	if (value % props.interval !== 0) {
		value = value - value % props.interval;
	} else {
		value = value - props.interval;
	}

	validateAndSetQty(value);
	announcedQty.value = qty.value;
}

function handlePlusClick() {
	let value = props.value;

	if (value % props.interval !== 0) {
		value = props.interval - value % props.interval + value;
	} else {
		value = value + props.interval;
	}

	validateAndSetQty(value);
	announcedQty.value = qty.value;
}

// Input validation
function validateAndSetQty(value: number) {
	if (props.disabled || value < props.min) {
		value = props.min;
	} else if (props.max && value > props.max) {
		value = props.max;
		emit('max-reached');
	}

	qty.value = value;
	emit('input', value);
}

function onBlur() {
	let numVal = coerceToNumber(qty.value);
	if (props.max && numVal > props.max) {
		numVal = props.max;
	}
	if (numVal) {
		validateAndSetQty(numVal);
		return;
	}

	if (props.tooltipError) {
		showToolTip.value = true;
		setTimeout(() => {
			showToolTip.value = false;
		}, props.tooltipTimeout);
	}

	validateAndSetQty(props.min);
}

function coerceToNumber(val: string | number): number | null {
	if (typeof val === 'number') {
		return val;
	}

	return NUMERIC_REGEX.test(val)
		? Number(val)
		: null;
}

watch(qty, (nextVal, prevVal) => {
	if (nextVal && nextVal != props.min && nextVal != prevVal) {
		validateAndSetQty(coerceToNumber(nextVal) || props.min);
	}
});

watch(() => props.value, nextVal => {
	if (nextVal && nextVal != qty.value) {
		qty.value = nextVal;
	}
}, {
	immediate: true,
});

return { __sfc: true,props, emit, disableMinusButton, disablePlusButton, showToolTip, qty, announcedQty, handleMinusClick, handlePlusClick, validateAndSetQty, onBlur, coerceToNumber, Icon, ToolTip }
}

})